<script setup lang="ts">
const carousels = [
  {
    title: 'Gagal Kirim'
  },
  {
    title: 'Sistem Notifikasi'
  },
  {
    title: 'Retur Sukses'
  },
  {
    title: 'Insight'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container flex flex-col gap-11 py-7 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />

    <UiContainer class="relative space-y-4">
      <UiSectionTitle
        class="text-center lg:mb-16"
        title="Solusi Retur Pengiriman Lebih Terkendali"
      />
      <UiCarouselFeature :per-page="4" :items="carousels" />
    </UiContainer>
  </div>
</template>
